export const dst = {
	auth: {
		initialized: 'dst.auth.initialized',
		initialSession: 'dst.auth.initialSession',
	},
	dom: {
		overlayFinished: 'dst.dom.overlay.finished',
	},
	notifications: {
		counter: 'notifications:counter',
	},
	user: {
		loggedIn: 'dst.user.loggedIn',
		loggedOut: 'dst.user.loggedOut',
		userAction: 'dst.user.userAction',
		userDataReceived: 'dst.user.userDataReceived',
		userIsActive: 'dst.user.userIsActive',
		userNotLoggedIn: 'dst.user.userNotLoggedIn',
	},
} as const;
